// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3rf9D","name":"Header_name__GNMKD","birthday":"Header_birthday__3oooq","skeleton":"Header_skeleton__2Xlb4"};